// https://vuetifyjs.com/en/getting-started/installation/#exposed-exports

import { aliases, fa } from "vuetify/iconsets/fa-svg";
import * as components from "vuetify/components";
import { VDateInput } from "vuetify/labs/VDateInput"
import * as directives from "vuetify/directives";
import { createVuetify } from "vuetify";
import "vuetify/styles";

export default function registerVuetifyPlugin() {
  const config = {
    components : {
      ...components,
      VDateInput,
    },
    directives,
    icons: {
      defaultSet: "fa",
      aliases,
      sets: {
        fa,
      },
    },
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          dark: false,
          colors: {
            // primary: '#d033333',
            success: "#66ff66",
            info: "#2196f3",
            error: "#b22222",
          },
        },
      },
    },
  };

  return createVuetify(config);
}
